import React, { useEffect, useState } from "react";
import _ from "lodash";
import { EVENT_PLANNING_RESOURCE_PLAN } from "../../../plannerConfig";
import {
  MultiWeekPlannerMainContainer,
  VisualisationSection,
} from "../multiWeekStyles.common";
import Visualisation from "../../Visualisations";
import LoadSpinnerOverlay from "../../LoadSpinner";

const ResourcePlan = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
  scenarioStringBuilder,
  activeFrontendFilters,
  filterData,
  appliedFilterForDashboard,
}) => {
  const { data, loadingQueue } = store[EVENT_PLANNING_RESOURCE_PLAN];
  const { GraphA } = data;
  const [prefConfig, setPrefConfig] = useState("stackBar");

  const getReserveCapacity = () => {
    const { get } = api;
    if (fromDate && toDate) {
      get([EVENT_PLANNING_RESOURCE_PLAN], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: scenarioStringBuilder(selectedScenarios),
        },
      });
    }
  };

  useEffect(() => {
    getReserveCapacity();
  }, [
    fromDate,
    toDate,
    durationAggregator,
    fromDateFilter,
    toDateFilter,
    selectedScenarios,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay
          text="Resource Plan Data Loading..."
          spinning={true}
        />
      </div>
    );
  }

  const onChangePrefConfig = (value) => {
    setPrefConfig(value);
  };

  const determineApplyFilter = (data) => {
    const returnedData =
      data && data.filter && Object.keys(data.filter).length > 0
        ? appliedFilterForDashboard(
            appliedFilterForDashboard(data, activeFrontendFilters, filterData),
            [],
            data.filter
          )
        : appliedFilterForDashboard(data, activeFrontendFilters, filterData);

    return returnedData;
  };

  const filteredGraphAData = determineApplyFilter(GraphA[0]);

  const visualisationData = {
    ...filteredGraphAData,
    data: filteredGraphAData,
    prefConfig,
    onChangePrefConfig,
  };

  return (
    <MultiWeekPlannerMainContainer>
      <div style={{ display: "flex", flex: "1" }}>
        <VisualisationSection>
          <Visualisation {...visualisationData} />
        </VisualisationSection>
      </div>
    </MultiWeekPlannerMainContainer>
  );
};

export default ResourcePlan;
